import router from './router'
import store from './store'
// import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
// import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

// const whiteList = ['/login'] // no redirect whitelist
const handleUrlToken = async (to, next) => {
  const urlToken = to.query.token
  if (urlToken) {
    try {
      store.commit('auth/SET_TOKEN', urlToken)

      const { token, ...otherQuery } = to.query
      next({
        path: to.path,
        query: otherQuery,
        replace: true
      })
      return true
    } catch (error) {
      console.error('URL token 存储失败：', error)
      return false
    }
  }
  return false
}

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  // 第一步：优先处理URL中的token
  const hasHandledUrlToken = await handleUrlToken(to, next)
  if (hasHandledUrlToken) return // 处理完token后，终止当前钩子，等待新的路由跳转

  // 第二步：执行原有鉴权逻辑（此时token已存入，不会跳登录）
  if (to.name !== 'login' && !store.getters.token) {
    next({ name: 'login' })
  } else {
    next()
  }
  // next()

  NProgress.done()
})

router.afterEach(() => {
  NProgress.done()
})

// router.beforeEach(async(to, from, next) => {
//   // start progress bar
//   NProgress.start()

//   // set page title
//   document.title = getPageTitle(to.meta.title)

//   // determine whether the user has logged in

//   if (hasToken) {
//     if (to.path === '/login') {
//       // if is logged in, redirect to the home page
//       next({ path: '/' })
//       NProgress.done()
//     } else {
//       const hasGetUserInfo = store.getters.name
//       if (hasGetUserInfo) {
//         next()
//       } else {
//         try {
//           // get user info
//           await store.dispatch('user/getInfo')

//           next()
//         } catch (error) {
//           // remove token and go to login page to re-login
//           await store.dispatch('user/resetToken')
//           Message.error(error || 'Has Error')
//           next(`/login?redirect=${to.path}`)
//           NProgress.done()
//         }
//       }
//     }
//   } else {
//     /* has no token*/

//     if (whiteList.indexOf(to.path) !== -1) {
//       // in the free login whitelist, go directly
//       next()
//     } else {
//       // other pages that do not have permission to access are redirected to the login page.
//       next(`/login?redirect=${to.path}`)
//       NProgress.done()
//     }
//   }
// })

// router.afterEach(() => {
//   // finish progress bar
//   NProgress.done()
// })
